import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { ApiService } from '../authentication/guards/api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { IOption } from 'ng-select';

@Injectable()
export class DashboardService {
  constructor(private apiService: ApiService) { }

  getDefaultDashboardCount() {
    return this.apiService.get('/defaultdashboardcount/').map(data => data);
  }
  getCRMDashboardCount(id) {
    return this.apiService.get('/crmdashboardcount/' + id).map(data => data);
  }
  getDashboardModuleCount(id) {
    return this.apiService.get('/dashboardcount/' + id).map(data => data);
  }

  getDashboardRequestList(id, type) {
    return this.apiService.get('/dashboardrequestlist/' + id + '/' + type).map(data => data);
  }
  getDashboardRequestFromAppList(id, type) {
    return this.apiService.get('/dashboardrequestfromapplist/' + id + '/' + type).map(data => data);
  }

  getDashboardNotificationList(id, type) {
    return this.apiService.get('/dashboardnotificationlist/' + id + '/' + type).map(data => data);
  }

  getDashboardRequestFromUserList(id, type) {
    return this.apiService.get('/dashboardrequestfromuserlist/' + id + '/' + type).map(data => data);
  }

  getDashboardOfferList(id, from, to) {
    return this.apiService.get('/dashboardofferforgraph/' + id + '/app/' + from + '/from/' + to).map(data => data);
  }

  getDashboardPageViewList(id, from, to) {
    return this.apiService.get('/dashboardpageviewlist/' + id + '/app/' + from + '/from/' + to).map(data => data);
  }

  getDashboardAppUsageList(id, from, to) {
    return this.apiService.get('/dashboardappusagelist/' + id + '/app/' + from + '/from/' + to).map(data => data);
  }

  getAppExpiryStatistics() {    
    return this.apiService.get('/appexpirystatistics/').map(data => data);
  }

  getApplicationListCount(AppId){
    return this.apiService.get('/applicationrequestlistcount/'+AppId).map(data => data);
  }

  getDashboardSMSCountList(id, from, to){    
    return this.apiService.get('/dashboardsmscountlist/' + id + '/app/' + from + '/from/' + to).map(data => data);
  }

  checkSMSOpted(AppId){
    return this.apiService.get('/checksmsoptedcms/'+AppId).map(data => data);
  }

  checkSMSSent(AppId){
    return this.apiService.get('/checksmssendfromcms/'+AppId).map(data => data);
  }

}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/dashboard-management/dashboard-management.ts